export default "__VITE_ASSET__36ca106e__"